import React, {useCallback, useContext} from "react";
import {useParams} from "react-router-dom";
import {Card} from "antd";
import {isEmpty} from "lodash";
import "../briefs.css";
import {ProviderBriefDetailsView} from "../ProviderBriefCard/ProviderBriefDetailsView.jsx";
import {useRequest} from "../../utils/hooks.jsx";
import {updateBid} from "../../api/bids/bids.js";
import {useHistory, useLocation} from "react-router-dom";

export const SystemBriefCard = () => {
    const {briefId} = useParams();
    const history = useHistory();
    const location = useLocation();
    const {bidId} = location.state || {};

    const [briefInfo, loadingBrief] = useRequest(`/api/briefs/${briefId}`, "POST", null, [briefId], !!briefId);

    const [bidInfo] = useRequest(`/api/bids/${bidId}`, "POST", null, [bidId], !!bidId);

    const [bidProduct] = useRequest(
        `/api/products/bidProduct/${bidInfo?.providerId}`,
        "GET",
        null,
        [bidInfo?.providerId],
        !!bidInfo?.providerId
    );

    const onSendBid = useCallback(
        async values => {
            const res = await updateBid({
                ...values,
                watchedByAdmin: true
            });

            if (res.error) {
                return;
            } else {
                history.push(`/system/briefs`);
            }
        },
        [history]
    );

    return (
        <>
            <div className="brief-container">
                <Card
                    className="brief-information-card-container"
                    bordered={false}
                    cover={
                        <div className="brief-information-card">
                            <div className="brief-information-card-top-bar-container">
                                <div className="brief-information-card-top-bar-item">
                                    <span className="title">נפתחה בקשת הצעת מחיר</span>
                                    קיבלנו בקשה מלקוח שיכולה להתאים לבית העסק שלך, נשמח שתעבור על הבריף ותשלח הצעת מחיר
                                </div>
                            </div>
                            <div className="brief-information-card-break-line" />
                            {!isEmpty(briefInfo) ? (
                                <div className="brief-information-card-section">
                                    <ProviderBriefDetailsView
                                        briefInfo={briefInfo}
                                        bidInfo={bidInfo}
                                        loadingBrief={loadingBrief}
                                        providerId={bidInfo?.providerId}
                                        onSendBid={onSendBid}
                                        bidProduct={bidProduct}
                                    />
                                </div>
                            ) : null}
                        </div>
                    }
                />
            </div>
        </>
    );
};
